import { injectIntl } from 'react-intl';
import { useState } from 'react';
import { Modal, Form, Input } from 'antd';

import { getCurrentUserHubInfo } from 'utils/hubs';
import { markHubAsLiable } from 'services/ops-control';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

const FORM_ID = 'HUB_IS_LIABLE_FORM';

const HubIsLiableModal = ({
  intl,
  close,
  title,
  allHubs,
  delivery,
  modalType,
  confirmEndPoint,
  ...rest
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const justificationFieldValue = Form.useWatch('justification', form);

  const currentUserHubId = getCurrentUserHubInfo()?._id;

  const onFinish = async (values) => {
    setIsLoading(true);

    const payload = {
      comment: values?.justification
    };

    try {
      const res = await markHubAsLiable(payload, delivery?._id);
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
      close();
    }
  };

  return (
    <Modal
      {...rest}
      title={intl.formatMessage({
        id: 'ops_control.lost_orders.hub_liable_modal.title'
      })}
      footer={
        <div className="br-lost-or-damaged-modal__footer">
          <BRButton
            label={intl.formatMessage({ id: 'common.cancel' })}
            onClick={close}
          />
          <BRButton
            disabled={isLoading || !justificationFieldValue}
            type="primary"
            htmlType="submit"
            form={FORM_ID}
            label={intl.formatMessage({ id: 'common.confirm' })}
          />
        </div>
      }
      centered
      onCancel={close}
    >
      <Form
        onFinish={onFinish}
        form={form}
        id={FORM_ID}
        className="br-lost-modal__form-wrapper"
        initialValues={currentUserHubId && { hub: currentUserHubId }}
      >
        <Form.Item
          rules={[{ required: true }]}
          label={
            <span className="body-medium">
              {intl.formatMessage({
                id: 'ops_control.lost_orders.hub_liable_modal.justification'
              })}
            </span>
          }
          name="justification"
          className="br-lost-modal__select-wrapper br-lost-modal__input-row"
        >
          <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default injectIntl(HubIsLiableModal);
